// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Bgxm","textarea":"styles_textarea__2Zvdc"};